<template>
	<article class="teaser teaser-story">
		<div
			class="teaser-story__cover"
			:class="{ 'teaser-story__cover-no-image': !imageSizes.length }"
		>
			<picture v-if="!imageSizes.length" class="teaser-story__image fallback">
				<img :src="fallbackImage()" alt="" />
			</picture>
			<picture v-else class="teaser-news__image normal">
				<source :srcset="imageSrcSet" />
				<img :src="imageSizes[0]" alt="" />
			</picture>
		</div>
		<div class="teaser-story__body">
			<h2 class="teaser-story__title heading--4">
				<a v-if="link" class="teaser__title-link" :href="link">{{ title }}</a>
				<span v-else>{{ title }}</span>
			</h2>
			<div class="teaser-story__name">{{ personName }}</div>
			<div class="teaser-story__function">{{ personFunction }}</div>
		</div>
	</article>
</template>
<script>
import { store } from "./store.js";
export default {
	name: "StoryTeaser",
	props: ["title", "link", "imageSizes", "personName", "personFunction"],
	data() {
		return {
			imageSrcSet: null,
		};
	},
	mounted: function () {
		if (this.imageSizes) {
			this.imageSrcSet = this.imageSizes
				.map((src, index) => {
					if (index == 0) {
						return `${src} 1x`;
					} else if (index === 1) {
						return `, ${src} 2x`;
					}
				})
				.join(" ");
		}
	},
	methods: {
		fallbackImage() {
			return `${window.THEME_LINK}/${store.storyTeaserFallbackImage}`;
		},
	},
};
</script>
